import { useEffect, useState } from 'react';

/** navigator.onLine, kept up to date (T4 §4.6). Apps may add a failed-request heartbeat on top. */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => window.navigator.onLine);
  useEffect(() => {
    const update = () => setOnline(window.navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);
  return online;
}
